import { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

// Components
import Grid from '@material-ui/core/Grid';
import Typography from 'components/CncUI/Typography';
import Loader from 'components/Loader';
import OffersTable from './OffersTable';
import SupportingDocuments from './SupportingDocuments';

// Hooks
import useGetMyFiles from './hooks/useGetMyFiles';

import Logger from 'utilities/logger';

const useStyles = makeStyles(({ breakpoints }) => ({
  header: {
    marginTop: 40,
    marginBottom: 0,
    [breakpoints.up('lg')]: {
      fontSize: 48,
      lineHeight: '56px',
    },
  },
  description: {},
}));

const MyFiles = () => {
  const logger = Logger('MyFiles');
  const classes = useStyles();
  const [response, loading, error, refreshData] = useGetMyFiles();
  const {
    myFiles = [],
    completedOffers = [],
    isAuthenticated = false,
  } = response;

  useEffect(() => {
    if (error) {
      logger.error(error);
    }
  }, [error]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} id="Header">
        <Typography variant="h2" className={classes.header}>
          My Files
        </Typography>
      </Grid>
      <Grid item xs={12} className={classes.description} id="Description">
        <Typography variant="body2" size="long">
          This is a collection of documents and files for you to use on existing
          and future projects.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        {loading ? (
          <Loader message="Loading your files..." />
        ) : (
          <>
            <SupportingDocuments
              myFiles={myFiles}
              isAuthenticated={isAuthenticated}
              fetchDataHandler={refreshData}
            />
            <OffersTable completedOffers={completedOffers} />
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default MyFiles;
